/**
 * 请求/响应拦截器配置
 * 在 main.ts 中引入以生效
 */

import type { AxiosRequestConfig } from 'axios'
import { addRequestInterceptor } from './request'
import { secureLocalStorage } from '@/utils/secureLocalStorage'

/** 后端按 Locationserver 替换响应 URL：管理端默认政务网 zhengwu */
function resolveLocationServer(): string {
  const raw = String(import.meta.env.VITE_LOCATION_SERVER ?? '').trim()
  return raw || 'zhengwu'
}

// 请求拦截：Locationserver + 后端鉴权 token
addRequestInterceptor(({ config }: { config: AxiosRequestConfig }) => {
  const headers = (config.headers ?? {}) as Record<string, string>
  headers.Locationserver = resolveLocationServer()
  const token = secureLocalStorage.getItem('token')
  if (token) {
    headers.token = token
  }
  config.headers = headers
})

// 响应拦截示例：addResponseInterceptor(({ data, response }) => { ... return data })
